// extracted by mini-css-extract-plugin
export default {"wrapper":"dWE44","image-card":"qcOJh","title":"aR2DQ"};